// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37v8p","field":"styles_field__3uSkG","fieldCol":"styles_fieldCol__201OG","diffCol":"styles_diffCol__3M2Cw","diff":"styles_diff__1h3BS"};